<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学导跟进数据</Breadcrumb-item>
        <Breadcrumb-item>电话沟通详情</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="70" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="主叫号码">
            <Input placeholder="支持模糊搜索" name="nickname" v-model="queryParam.callTel"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="被叫号码">
            <Input placeholder="支持模糊搜索" name="mobile" v-model="queryParam.calledTel"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" listUrl="/tel/listDetails"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>

</template>
<script>
  export default {
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        queryParam: {
          studyAdviserId: '',
          startTimeSec: '',
          endTimeSec: '',
          callTel: '',
          calledTel: '',
        },
        title: [
          {
            title: '主叫号码',
            key: 'callNo'
          },
          {
            title: '被叫号码',
            key: 'calledNo'
          },
          {
            title: '响铃时间',
            key: 'ringStr'
          },
          {
            title: '电话接通时间',
            key: 'beginStr'
          },
          {
            title: '电话结束时间',
            key: 'endStr'
          },
          {
            title: '通话时长',
            key: 'endStr',
            render: (h, params) => {
              let row = params.row
              if (((row.end - row.begin) / (1000 * 60)).toFixed(2) > 1) {
                return h('span', ((row.end - row.begin) / (1000 * 60)).toFixed(2) + ' 分钟')
              } else {
                return h('span', ((row.end - row.begin) / (1000)).toFixed(0) + ' 秒')
              }
            }
          },
          {
            title: '处理工号',
            key: 'agent'
          },
          {
            title: '处理人',
            key: 'agentName'
          },
          {
            title: '处理结果',
            key: 'attendLessonRate',
            render: (h, params) => {
              let telState = params.row.state
              let typeEnum = $constant.getEnum($constant.telState, telState)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '语音文件',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.downLoadFile(row)}}, '查看')
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.studyAdviserId = localStorage.studyAdviserId
      this.queryParam.startTimeSec = localStorage.startTime
      this.queryParam.endTimeSec = localStorage.endTime
    },
    methods: {
      downLoadFile (row) {
        window.open(row.fileServer + '/' + row.recordFile)
      },
      search () {
        this.$refs.dataList.search()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }

</script>



// WEBPACK FOOTER //
// TelDetails.vue?0546875c